import * as actionTypes from './actionTypes'

export const screenResize = ({ width, height }) => ({
  type: actionTypes.SCREEN_RESIZE,
  width,
  height
})

export const showSnackbar = message => ({
  type: actionTypes.SHOW_SNACKBAR,
  message
})

export const expandCard = previewId => ({
  type: actionTypes.EXPAND_CARD,
  previewId
})

export const setTheme = theme => ({
  type: actionTypes.SET_THEME,
  theme
})

export const setProcessing = bool => ({
  type: actionTypes.SET_PROCESSING,
  bool
})

export const toggleMobileNavDrawer = bool => ({
  type: actionTypes.TOGGLE_MOBILE_NAV_DRAWER,
  bool
})

export const pushHistory = obj => ({
  type: actionTypes.ADD_HISTORY,
  obj
})

export const setHistoryCursor = cursor => ({
  type: actionTypes.SET_HISTORY_CURSOR,
  cursor
})
export const updateHistoryWithLabel = ({ path, search, title, subtitle }) => ({
  type: actionTypes.UPDATE_HISTORY_WITH_LABEL,
  path,
  search,
  title,
  subtitle
})

export const setUserTab = tab => ({
  type: actionTypes.SET_USER_TAB,
  tab
})

export const setTypeaheadNoContactsFound = bool => ({
  type: actionTypes.SET_TYPEAHEAD_NO_CONTACTS_FOUND,
  bool
})

export const togglePrintPane = bool => ({
  type: actionTypes.TOGGLE_PRINT_PANE,
  bool
})

export const setNameForDocumentTitle = name => ({
  type: actionTypes.SET_NAME_FOR_DOCUMENT_TITLE,
  name
})

export const triggerSubscriberWelcomeModal = bool => ({
  type: actionTypes.TRIGGER_SUBSCRIBER_WELCOME_MODAL,
  bool
})

export const setBladeExpanded = id => ({
  type: actionTypes.SET_BLADE_EXPANDED,
  id
})

export const sliceHistoryAtCursor = () => ({
  type: actionTypes.SLICE_HISTORY_AT_CURSOR
})

export const removeLastHistoryItem = () => ({
  type: actionTypes.REMOVE_LAST_HISTORY_ITEM
})

export const setHaveZipOnTaxDetail = bool => ({
  type: actionTypes.SET_HAVE_ZIP_ON_TAX_DETAIL,
  bool
})

export const pushRoute = route => ({
  type: actionTypes.PUSH_ROUTE,
  route
})

export const showPropertyActionsSheet = property => ({
  type: actionTypes.SHOW_PROPERTY_ACTIONS_SHEET,
  property
})

export const hidePropertyActionsSheet = () => ({
  type: actionTypes.HIDE_PROPERTY_ACTIONS_SHEET
})
